<template>
    <div id="tradeTrackerCategories">
        <div class="table-header">
            <div class="flex flex-wrap w-full">
                <div class="sm:flex-1 w-full pr-3 xs:pr-0 xs:pb-2">
                    <span class="btn btn-blue btn-xs" @click="addCategory">
                        <i class="fas fa-plus"></i>
                        Add a new Category
                    </span>
                </div>
                <div class="justify-center sm:ml-auto">
                    <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1 xs:ml-0" @click="handleClose">Cancel</div>
                    <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="handleSave">Save</div>
                </div>
            </div>
        </div>

        <alert-box v-if="categories.length === 0">
            <template #body>
                You do not have any categories.
            </template>
        </alert-box>

        <table v-if="categories.length > 0" class="table table-striped table-hover border border-t-0">
            <thead>
                <tr>
                    <th class="w-16 text-center">Sort</th>
                    <th>Category Name</th>
                    <th class="text-center">Active</th>
                    <th class="w-24 text-center">Delete</th>
                </tr>
            </thead>
            <draggable v-model="categories" tag="tbody" handle=".canDrag" item-key="id">
                <template #item="{ element, index }">
                    <tr>
                        <td class="text-center cursor-move canDrag">
                            <i class="fas fa-arrows-alt text-gray-500"></i>
                        </td>
                        <td>
                            <div class="error" v-show="element.error">{{ element.error }}</div>
                            <input :ref="`category-${index}`" :class="{'is-invalid': element.error}" class="form-input-inline-w-none form-input-sm-inline w-full" type="text" v-model="element.name" maxlength="40" />
                        </td>
                        <td class="text-center">
                            <input type="checkbox" v-model="element.active" :true-value="1" :false-value="0" />
                        </td>
                        <td class="text-center">
                            <a v-if="categories.length > 1" @click="removeCategory(index)" v-tooltip="{ content: 'Delete Current Category', placement: 'auto-start', theme: 'red' }" class="btn btn-default btn-shadow-none btn-red-ghost btn-xs ml-1 mb-1 md:mb-0" title="Delete Category">
                                <i class="fas fa-times"></i>
                            </a>
                        </td>
                    </tr>
                </template>
            </draggable>
            <tfoot>
                <tr>
                    <th class="text-center">Sort</th>
                    <th>Category Name</th>
                    <th class="text-center">Active</th>
                    <th class="text-center">Delete</th>
                </tr>
            </tfoot>
        </table>

        <div class="flex justify-center mt-4">
            <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1 xs:ml-0" @click="handleClose">Cancel</div>
            <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="handleSave">Save</div>
        </div>

        <flash-message ref="flash" :seconds-to-display="6"></flash-message>

    </div>
</template>

<script setup>
import { ref } from 'vue';
import Draggable from 'vuedraggable';

const props = defineProps({
    pasCategories: {
        type: [Object, Array],
        required: true
    }
});

const flash = ref(null);
const categories = ref(JSON.parse(JSON.stringify(props.pasCategories)));

function handleClose() {
    window.location = window.route('admin.jims-trade-tracker.index');
}

function handleValidate() {
    let valid = true;
    categories.value = categories.value.map(pCategory => {
        if (pCategory.name === '') {
            pCategory.error = 'Please enter a category name';
            valid = false;
        }
        return pCategory;
    });
    return valid;
}

function handleSave() {
    if (!handleValidate()) {
        return;
    }

    const route = window.route('admin.jims-trade-tracker.batch-update');
    axios.post(route, { categories: categories.value })
        .then(response => {
            flash.value.display("Successfully saved «Jim's Trade Tracker Categories»!");
            window.location = window.route('admin.jims-trade-tracker.index');
        }).catch(error => {
            if (error.response && error.response.data.success == 'false') {
                flash.value.error(error.response.data.error);
            }
            console.error(error);
        });
}

function addCategory() {
    categories.value.push({ name: '', active: false });
    // nextTick(() => {
    //     this.$refs['category-' + (this.categories.length - 1)][0].focus();
    // });
}

function removeCategory(index) {
    categories.value.splice(index, 1);
}
</script>

<style lang="scss">
#tradeTrackerCategories {
    @apply border-t-2 border-blue-600 mt-6;
    table {
        thead,
        tfoot {
            td, th {
                @apply px-2 py-1;
            }
        }
        tbody {
            td, th {
                @apply px-2;
            }
        }
        .sortable {
            @apply cursor-pointer;
        }
    }
}
</style>
